<div class="modal fade shares-modal" role="dialog">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
        <h4 class="modal-title">Like this video? Share it. It really helps!</h4>
      </div>
      <div class="modal-body">
        <div class="">
          <div class="text-center">
            <p>
              You can copy the iframe code to embed the Captionz player on your
              website.
              <br />
              See what it looks like at
              <a
                href="https://pnl.dev/category/5/captionz-trove"
                target="_blank"
              >
                Captionz Trove
              </a>
            </p>

            <div class="form-horizontal">
              <div class="form-group">
                <label class="col-xs-4 col-md-4" for="iframeCode">
                  <img [src]="imgSrc" alt="preview image" />
                </label>
                <div class="col-xs-8 col-md-8">
                  <textarea
                    name="iframeCode"
                    class="form-control"
                    rows="2"
                    [value]="iframeCode"
                    onclick="this.focus();this.select()"
                    readonly="readonly"
                    id="iframeCode"
                    data-toggle="toggle"
                  ></textarea>
                </div>
              </div>
            </div>
          </div>
        </div>
        <p class="text-center">Or share it on your network:</p>
        <div
          id="i-share"
          [attr.data-share-url]="shareUrl"
          data-share-networks="Twitter,Pinterest,Facebook,Reddit,Linkedin,Tumblr,mailto,Evernote,Wechat,Douban"
          class="need-share-panel need-share-button"
        ></div>
      </div>
    </div>
    <!-- /.modal-content -->
  </div>
  <!-- /.modal-dialog -->
</div>
<!-- /.modal -->
